__turbopack_context__.v({
  "addressWrapper": "ipNn8q_addressWrapper",
  "container": "ipNn8q_container",
  "containerPrivateOffice": "ipNn8q_containerPrivateOffice",
  "ctaButton": "ipNn8q_ctaButton",
  "detailsWrapper": "ipNn8q_detailsWrapper",
  "headline": "ipNn8q_headline",
  "imageContainer": "ipNn8q_imageContainer",
  "imageContainerWrapper": "ipNn8q_imageContainerWrapper",
  "licensePartnerText": "ipNn8q_licensePartnerText",
  "linksWrapper": "ipNn8q_linksWrapper",
  "section": "ipNn8q_section",
  "shopLicenseText": "ipNn8q_shopLicenseText",
  "shopWrapper": "ipNn8q_shopWrapper",
});
